var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21,
    fill: "#FAFAFA",
    stroke: "#A5BFDF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2188 14.6251H30.7286L25.5156 9.41211V13.922C25.5156 14.3099 25.8308 14.6251 26.2188 14.6251Z",
    fill: "#1A9825"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7031 20.2969H25.5156V21.7031H22.7031V20.2969Z",
    fill: "#1A9825"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7031 23.1094H25.5156V24.5156H22.7031V23.1094Z",
    fill: "#1A9825"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4844 23.1094H21.2969V24.5156H18.4844V23.1094Z",
    fill: "#1A9825"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7031 25.9219H25.5156V27.3281H22.7031V25.9219Z",
    fill: "#1A9825"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9688 33H29.0312C30.1944 33 31.1406 32.0538 31.1406 30.8906V16.0312H26.2188C25.0556 16.0312 24.1094 15.085 24.1094 13.9219V9H14.9688C13.8056 9 12.8594 9.94622 12.8594 11.1094V30.8906C12.8594 32.0538 13.8056 33 14.9688 33ZM17.0781 19.5938C17.0781 19.2051 17.3926 18.8906 17.7812 18.8906H26.2188C26.6074 18.8906 26.9219 19.2051 26.9219 19.5938V28.0312C26.9219 28.4199 26.6074 28.7344 26.2188 28.7344H17.7812C17.3926 28.7344 17.0781 28.4199 17.0781 28.0312V19.5938Z",
    fill: "#1A9825"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4844 25.9219H21.2969V27.3281H18.4844V25.9219Z",
    fill: "#1A9825"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4844 20.2969H21.2969V21.7031H18.4844V20.2969Z",
    fill: "#1A9825"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg4);
export default __webpack_public_path__ + "static/media/svg4.fe23c1f5c669f809209f1cfa92d19e45.svg";
export { ForwardRef as ReactComponent };